<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText">
    <b-field class="file" :type="{'is-danger': errors.length }" :message="errors[0]">
      <b-upload v-model="file" :required="true" @input="(file) => handleFileInput(file)">
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>{{label}}</span>
        </a>
      </b-upload>
    </b-field>

    <!-- <div v-if="fileExists">
      <div>{{ file.name }}</div>
      <button class="button is-primary">
        <b-icon icon="upload" class="has-margin-right-10"></b-icon>Upload Document
      </button>
    </div>-->
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

/**
 * Custom Form input with validation setup
 */
export default {
  name: "FileInputWithValidation",
  props: {
    rules: { type: String, required: true },
    model: { type: String | Boolean },
    label: { type: String, default: "Upload File" },
    vuexKey: { type: String, required: true },
    name: { type: String, required: true },
    errorLabel: { type: String }
  },

  components: {
    ValidationProvider
  },

  data() {
    return {
      file: this.model
    };
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    },

    fileExists() {
      // Check that the file exists and its not an empty object
      if (
        this.file &&
        !(
          Object.keys(this.file).length === 0 &&
          this.file.constructor === Object
        )
      ) {
        return true;
      }

      return false;
    }
  },

  methods: {
    handleFileInput: function(file) {
      this.$emit("input", { key: this.vuexKey, value: file });
    }
  }
};
</script>


